module.exports = __webpack_public_path__ + "static/media/ZEC.bbca2108.pdf";